<template>
  <div id="index" style="max-width:600px;margin:0 auto;">
    <v-layout>
      <v-spacer></v-spacer>
      <v-chip flat dark color="primary">カラログを登録</v-chip>
    </v-layout>
    <object-search
      @onSelect="onSelect"
      @onSelectNoFood="onSelectNoFood"
    ></object-search>
  </div>
</template>

<script>
import ObjectSearch from '@/components/card/ObjectSearch.vue'
export default {
  name: 'ReviewPostFoodSearchView',
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
    this.scrollIni()
  },
  methods: {
    scrollIni () {
      window.scrollTo(0, 0)
    },
    onSelectNoFood () {
      this.$router.push({name: 'reviewPostViewNoFood', params: {mode: 'noFood'}})
    },
    onSelect (type) {
      if (type === 'shop' || type === 'google') {
        this.$router.push({name: 'reviewPostViewShop'}) 
      } else {
        this.$router.push({name: 'reviewPostView'})
      }
    }
  },
  components: {
    ObjectSearch
  },
  head: {
    title () {
      return {
        inner: `食品検索`,
        separator: ' ',
        complement: 'カラログ投稿'
      }
    },
    meta () {
      return [
        {name: 'description', content: 'カラログ投稿する食品を検索します。｜激辛口コミグルメサイト「カライイネ」'}
      ]
    },
    link () {
      return [
        {rel: 'canonical', href: 'https://karaiine.jp/'}
      ]
    }
  }
}
</script>

<style scoped>
  #index{
    min-height:90vh;
    text-align:center;
  }
</style>